const globalAttributes = ["name", "required", "value"];

export default globalAttributes;
